import { useContext, useEffect } from 'react';

import AnalyticsClient from '../clients/AnalyticsClient';
import AnalyticsContext from '../context/Analytics';

export function useAnalytics(): AnalyticsClient {
  return useContext(AnalyticsContext);
}

export function useAnalyticsOnMount(callback: (analyticsClient: AnalyticsClient) => void): void {
  const analytics = useAnalytics();
  useEffect(() => {
    callback(analytics);
  }, []);
}
